import React from 'react';
import styled from '@emotion/styled';
import { ThemeProvider } from '@emotion/react';

import { GlobalStyle, theme } from '../../../../main/scripts/lumen';
import logoInsightsHub from './assets/logo-insights-hub.svg';
import waveBg from './assets/wave-bg.png';

export const AuthCard = ({ children, aside }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <PageWrapper>
      <Card>
        <Logo src={logoInsightsHub} alt="Cemantica Insights hub" />
        {children}
      </Card>
      {aside}
    </PageWrapper>
  </ThemeProvider>
);

export const AuthHeading = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 28px;
  color: ${({ theme }) => theme.color.fg.default};
  text-align: center;
`;

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 80px;
  padding: 100px 240px 196px 240px;
  background: ${({ theme }) => theme.color.bg.subtle}
  url(${waveBg}) center / cover no-repeat;

  /* Tablet — collapse Figma's huge desktop offset, center card. */
  @media (max-width: 1024px) {
    padding: 40px;
    justify-content: center;
  }

  /* Mobile — minimal padding, card near top. */
  @media (max-width: 640px) {
    padding: 40px 16px 16px;
    align-items: flex-start;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 100px ${({ theme }) => theme.color.bg.default} inset;
    -webkit-text-fill-color: ${({ theme }) => theme.color.fg.default};
    caret-color: ${({ theme }) => theme.color.fg.default};
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 560px;
  min-height: 689px;
  background: ${({ theme }) => theme.color.bg.default};
  border: 1px solid ${({ theme }) => theme.color.slate[200]};
  border-radius: 24px;
  padding: 24px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);

  /* Mobile — drop fixed 689px height and tighten side padding. */
  @media (max-width: 640px) {
    min-height: auto;
    padding: 32px 24px;
    border-radius: 16px;
  }

  input[type='text'],
  input[type='password'] {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    box-shadow: none;
    background: ${({ theme }) => theme.color.bg.default};
    padding: 0 8px;
    height: 32px;

    &:focus {
      border-color: ${({ theme }) => theme.color.primary.base};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.color.blue[100]};
    }
  }
`;

const Logo = styled.img`
  width: 160px;
  height: 51px;
  display: block;
`;
